import { render, staticRenderFns } from "./flowDetail.vue?vue&type=template&id=60f9817a&scoped=true&"
import script from "./flowDetail.vue?vue&type=script&lang=js&"
export * from "./flowDetail.vue?vue&type=script&lang=js&"
import style0 from "./flowDetail.vue?vue&type=style&index=0&id=60f9817a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9817a",
  null
  
)

export default component.exports